import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ProductCustomer } from "src/app/main/model/ddb.model";
import { CustomerProductService } from "src/app/main/services/customerProduct.service";
import { Utils } from "src/app/main/util/utils";

@Component({
  selector: "app-backorder-products-email-preview",
  templateUrl: "./backorder-products-email-preview.component.html",
  styleUrls: ["./backorder-products-email-preview.component.sass"],
  styles: [
    `
      .order-img {
        background: $color_8;
        border-radius: 1.15rem;
        -webkit-border-radius: 1.15rem;
        -moz-border-radius: 1.15rem;
        -ms-border-radius: 1.15rem;
        -o-border-radius: 1.15rem;
        height: 11.5rem;
        padding: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          mix-blend-mode: multiply;
        }
      }
    `,
  ],
})
export class BackorderProductsEmailPreviewComponent {
  @Input() products: ProductCustomer[] = [];
  @Output() approvalSent = new EventEmitter<void>();
  @Input() email: string = "admin@gmail.com";

  constructor(
    private customerProductService: CustomerProductService,
    public utils: Utils,
  ) {
    window.scroll(0, 0);
  }

  sendBulkApprovalRequest(): void {
    const ids = this.products
      .map((product) => product.id)
      .filter((id): id is number => id !== undefined)
      .map((id) => id.toString());

    if (!ids.length) {
      return;
    }

    this.customerProductService
      .bulkSendSubstituteApproval(ids)
      .subscribe(() => {
        this.approvalSent.emit();
      });
  }

  getOriginalProductPrice(product: ProductCustomer): number {
    return product.customPrice
      ? product.customPrice
      : product.product.price || product.product.basePrice || 0;
  }

  getPriceComparison(productPrice: number, substitutePrice: number): string {
    const difference = substitutePrice - productPrice;

    if (difference < 0) {
      return `Save $${this.utils.twoDecimalPlacesString(Math.abs(difference))}`;
    }

    if (difference > 0) {
      return `+$${this.utils.twoDecimalPlacesString(difference)} per item`;
    }

    return "No price change";
  }
}
